import React from "react";
import _ from "lodash";
import "./displaystyles.css";
import moment from "moment";
import { languageService } from "../../../../../../../Language/language.service";
import { versionInfo } from "../../../../../../MainPage/VersionInfo";
const Display = ({ entry, onSelect, onFormSelect, selectedRowData }) => {
  const { mpStart, mpEnd, user, date, forms, active, closed, actionState } = entry;

  let style = selectedRowData._id === entry.id ? "select-div" : "not-select-div";

  const row2 = [
    {
      name: "MP Start",
      entry: mpStart,
    },

    {
      name: "MP End",
      entry: mpEnd,
    },

    { name: "", entry: null },
  ];

  const row1 = [
    {
      name: "User",
      entry: user,
    },

    {
      name: "Date",
      entry: date ? moment(date).format("llll") : date,
    },

    { name: "State", entry: actionState },
  ];
  const activeColorStyles = selectedRowData._id === entry.id ? (versionInfo.isReVAMP() ? { backgroundColor: "var(--first)" } : {}) : {};
  return (
    <div
      className="entry-container"
      onClick={(e) => {
        onSelect(entry.id);
      }}
    >
      <div className={style} style={activeColorStyles}></div>

      <div className="entry-details">
        <DisplayDetails detailsDisplay={row1} />
      </div>

      {!versionInfo.isReVAMP() && (
        <div className="entry-details">
          <DisplayDetails detailsDisplay={row2} />
        </div>
      )}
      {forms.length !== 0 && <FormDisplay forms={forms} entry={entry} onFormSelect={onFormSelect} />}
    </div>
  );
};

export default Display;

const DisplayDetails = ({ detailsDisplay }) => {
  return detailsDisplay.map((obj) => {
    let circleClass = "";

    if (obj.name === "Active") {
      if (obj.entry) {
        circleClass = "active-circle";
      } else {
        circleClass = "notactive-circle";
      }
    }

    return circleClass ? (
      <div className={circleClass}></div>
    ) : (
      <div className="details-section">
        <span>
          <small className="small-head">
            {languageService(obj.name)} {obj.name ? ":" : ""}
          </small>
          <small className="small-para"> {languageService(obj.entry)} </small>
        </span>
      </div>
    );
  });
};

const FormDisplay = ({ forms, entry, onFormSelect }) => {
  forms = forms.filter((obj) => obj && !_.isEmpty(obj));
  forms = forms.filter((obj) => (obj && obj.id ? true : false && obj.name ? true : false));

  return (
    <ul className="forms-list">
      <li>
        <small className="small-head"> {languageService("Forms")}:</small>
      </li>

      {forms.map((form) =>
        form ? (
          <li
            onClick={(e) => {
              onFormSelect(form.id, entry.id);
            }}
            key={form.id}
            className="form-item"
          >
            <small className="small-para">{form.name}</small>
          </li>
        ) : null,
      )}
    </ul>
  );
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/ExecutionDetail/MultiExecutionDetail.jsx/RailStatus/Display.js